import http from './http'

export const getReportType = async () => {
	const reports = await http.get('/report/reportslist')
	return reports.data.ReportsList
}

export const getDocsType = async () => {
	const a = await http.post('/regis/academDocList')
	return a.data.AcademDocList
}
